export default __webpack_public_path__ + "static/media/Black Dragon Tail.c2a3b335.jpg";